// @core/api/endpoints/analytics/get_widget.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  WidgetResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Get widget
 * Retrieves a widget by ID including its data source configuration and display options.
 */
export async function GetWidget(
  widget_id: string,
  options?: RequestOptions
): Promise<WidgetResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/widgets/:widget_id`;
  requestPath = requestPath.replace(':widget_id', encodeURIComponent(widget_id));
  const requestOptions = options;
  return client.get<WidgetResponse>(requestPath, { ...requestOptions });
}
